module.exports = {
    default_login: '',
    default_pass: '',
    mode: 'gmbh',
    // mode: 'acc',
    // hide_fix_damages: true,
    // hide_sales_preference: true,
    disable_SIRV: true,
    //  enable_hemex: true,
    requiredFieldsPersonal: [],
    requiredFieldsCommercial: [],
    requiredFieldsElectric: [],
    mode: 'gmbh',
    clientId: 4,
    hexon: true,
    vehicle_details_show_special_button: true,
    hide_fix_damages: true,
    hide_picked_up: true,
    hide_sell_with_license_plate: true,
    hide_sales_preference: true,
    disable_SIRV:true,
    enable_hemex : true,
    hide_transport_card: true,
    hide_website_card : true,
    wientjes_installation: false,

    // hide_inspection_card : true,
    hide_photos_card : true,
    hide_other_buttons : true,
    hide_inspection_filter : true,
    hide_mandatory_field_outgoing_order : true,
    hide_transaction_result : true,
    hide_products : true ,
    hide_bpm_card : true ,

    hide_rdw_card : true,
    hide_payment_filter : true,
    hide_company_structure_card: true,
    hide_counterscard: true,
    user_filter_list : [
        {
            label:'admin',
            value:1
        }
    ],
};
